var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVoifinityblack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 153,
    viewBox: "0 0 300 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3432 150.989L22.7036 140.068H24.2634L25.9965 145.442C26.5165 147.002 26.8631 148.215 27.2097 149.602C27.5563 148.389 27.9029 147.002 28.4229 145.442L30.3293 140.068H31.8891L27.9029 150.989H26.3432Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8735 145.268C48.8735 149.082 46.6204 150.989 43.8475 150.989C40.9012 150.989 38.9948 148.735 38.9948 145.442C38.9948 141.975 41.0745 139.721 44.0208 139.721C46.9671 139.721 48.8735 142.148 48.8735 145.268ZM40.3813 145.442C40.3813 147.869 41.5944 149.949 43.8475 149.949C46.1005 149.949 47.3137 147.869 47.3137 145.442C47.3137 143.188 46.1005 140.935 43.8475 140.935C41.5944 140.935 40.3813 143.188 40.3813 145.442Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5789 139.894V150.816H57.1924V139.894H58.5789Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2166 150.642C74.6967 150.816 73.6568 151.162 72.2704 151.162C69.1508 151.162 66.8977 149.255 66.8977 145.615C66.8977 142.148 69.1508 139.894 72.617 139.894C74.0035 139.894 74.87 140.241 75.2166 140.414L74.87 141.628C74.3501 141.281 73.6568 141.108 72.617 141.108C70.0173 141.108 68.2842 142.668 68.2842 145.615C68.2842 148.389 69.844 149.949 72.4437 149.949C73.3102 149.949 74.1768 149.775 74.6967 149.429L75.2166 150.642Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2548 145.788H84.922V149.775H89.6014V150.989H83.3622V140.068H89.2548V141.281H84.922V144.748H89.2548V145.788Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M109.359 141.108H106.066V139.894H114.211V141.108H110.919V150.816H109.532V141.108H109.359Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M130.849 145.268C130.849 149.082 128.596 150.989 125.823 150.989C122.877 150.989 120.971 148.735 120.971 145.442C120.971 141.975 123.05 139.721 125.997 139.721C128.943 139.721 130.849 142.148 130.849 145.268ZM122.357 145.442C122.357 147.869 123.57 149.949 125.823 149.949C128.076 149.949 129.289 147.869 129.289 145.442C129.289 143.188 128.076 140.935 125.823 140.935C123.57 140.935 122.357 143.188 122.357 145.442Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M150.607 139.894V150.816H149.22V139.894H150.607Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M159.619 150.989V140.068H161.179L164.645 145.615C165.511 146.828 166.031 148.042 166.551 149.255C166.378 147.869 166.378 146.482 166.378 144.748V140.241H167.764V151.162H166.378L162.912 145.615C162.218 144.402 161.352 143.188 160.832 141.975C160.832 143.361 161.005 144.748 161.005 146.482V151.162H159.619V150.989Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M176.776 139.894H182.669V141.108H178.163V144.748H182.322V145.962H178.163V150.989H176.776V139.894Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M192.721 139.894V150.816H191.334V139.894H192.721Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M201.56 150.989V140.068H203.12L206.586 145.615C207.452 146.828 207.972 148.042 208.492 149.255C208.319 147.869 208.319 146.482 208.319 144.748V140.241H209.705V151.162H208.319L204.853 145.615C204.159 144.402 203.293 143.188 202.773 141.975C202.773 143.361 202.946 144.748 202.946 146.482V151.162H201.56V150.989Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M220.277 139.894V150.816H218.891V139.894H220.277Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M231.369 141.108H228.076V139.894H236.222V141.108H232.929V150.816H231.542V141.108H231.369Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M246.794 150.989V146.308L243.328 140.068H244.887L246.447 143.015C246.794 143.881 247.14 144.575 247.487 145.268C247.834 144.575 248.18 143.881 248.527 143.015L250.087 140.068H251.646L248.007 146.308V150.989H246.794Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M212.825 79.0481C216.366 79.0481 219.237 76.1765 219.237 72.6342C219.237 69.0918 216.366 66.2202 212.825 66.2202C209.283 66.2202 206.412 69.0918 206.412 72.6342C206.412 76.1765 209.283 79.0481 212.825 79.0481Z",
    fill: "url(#paint0_linear_1_3)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M217.331 69.3405C217.331 70.9006 215.251 72.1141 212.825 72.1141C210.399 72.1141 208.319 70.9006 208.319 69.3405C208.319 67.7803 210.399 66.5669 212.825 66.5669C215.425 66.5669 217.331 67.7803 217.331 69.3405Z",
    fill: "url(#paint1_linear_1_3)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M216.118 76.9679C216.118 78.008 214.731 78.8748 212.998 78.8748C211.265 78.8748 209.879 78.008 209.879 76.9679C209.879 75.9278 211.265 75.0611 212.998 75.0611C214.558 75.0611 216.118 75.9278 216.118 76.9679Z",
    fill: "url(#paint2_linear_1_3)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M103.813 79.0481C107.354 79.0481 110.225 76.1765 110.225 72.6342C110.225 69.0918 107.354 66.2202 103.813 66.2202C100.271 66.2202 97.4003 69.0918 97.4003 72.6342C97.4003 76.1765 100.271 79.0481 103.813 79.0481Z",
    fill: "url(#paint3_linear_1_3)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M108.319 69.3405C108.319 70.9006 106.239 72.1141 103.813 72.1141C101.386 72.1141 99.3068 70.9006 99.3068 69.3405C99.3068 67.7803 101.386 66.5669 103.813 66.5669C106.412 66.5669 108.319 67.7803 108.319 69.3405Z",
    fill: "url(#paint4_linear_1_3)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M106.932 76.9679C106.932 78.008 105.546 78.8748 103.813 78.8748C102.08 78.8748 100.693 78.008 100.693 76.9679C100.693 75.9278 102.08 75.0611 103.813 75.0611C105.546 75.0611 106.932 75.9278 106.932 76.9679Z",
    fill: "url(#paint5_linear_1_3)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M110.399 79.2215C110.225 79.2215 110.052 79.2215 109.879 79.2215C110.052 79.0481 110.399 78.8748 110.572 78.8748C111.612 78.3547 113.172 77.488 114.731 75.4078C116.811 72.8075 118.544 68.6471 120.797 63.4465C121.317 62.4064 121.664 61.193 122.184 59.9795C124.783 54.0856 128.769 45.0713 136.915 37.0972C144.541 29.2964 157.886 24.2692 171.577 23.5758C173.484 23.4024 175.563 23.4024 177.47 23.4024C189.948 23.4024 200.867 26.0027 208.839 31.0299C220.624 38.1373 223.57 49.4051 224.263 53.9122C226.17 68.127 222.184 76.7946 221.49 77.3146C221.317 77.3146 221.317 75.4078 221.317 73.6743C221.49 69.6872 221.664 63.0998 219.757 54.6056C218.198 48.5383 214.558 40.2175 205.199 35.1903C198.44 31.2032 188.735 28.9497 177.643 28.9497C175.737 28.9497 173.83 28.9496 171.924 29.123C147.14 29.2964 133.449 46.6315 126.69 61.193L125.997 62.4064C122.877 68.3004 120.104 73.5009 116.638 76.4479C113.865 79.0481 111.265 79.2215 110.399 79.2215Z",
    fill: "url(#paint6_linear_1_3)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M177.816 23.0557V23.5758C190.295 23.5758 201.213 26.176 209.185 31.2032C220.971 38.3106 223.743 49.4051 224.437 53.9122C226.17 66.5669 223.224 74.8877 222.01 76.7946C221.837 76.2745 222.01 74.8877 222.01 73.6743C222.184 69.6872 222.357 63.0998 220.451 54.6056C218.891 48.5383 215.078 40.2175 205.893 35.0169C199.133 31.0299 189.255 28.7763 178.163 28.7763C176.257 28.7763 174.35 28.7763 172.444 28.9497C146.967 29.2964 133.449 46.6315 126.516 61.193L125.823 62.4064C122.704 68.3004 119.931 73.5009 116.464 76.4479C113.865 78.7014 111.612 79.0481 110.572 79.0481C111.612 78.5281 113.345 77.6613 114.905 75.5811C116.984 72.9809 118.718 68.8204 120.971 63.4465C121.49 62.4064 121.837 61.193 122.357 59.9795C124.957 54.0856 128.943 45.0713 137.088 37.2705C144.714 29.6431 157.886 24.4425 171.577 23.9225C173.484 23.7491 175.563 23.7491 177.47 23.7491V23.0557M177.816 23.0557C175.91 23.0557 173.83 23.0557 171.924 23.2291C158.232 23.7491 144.887 28.9497 137.088 36.7505C129.116 44.5513 125.303 52.8721 122.184 59.6328C119.237 66.3935 117.158 71.9407 114.731 75.0611C112.305 78.1814 109.532 78.5281 109.705 79.0481C109.705 79.0481 109.879 79.2215 110.572 79.2215C111.785 79.2215 114.385 78.7014 116.984 76.4479C120.624 73.3276 123.57 67.607 127.036 61.193C133.102 48.365 146.274 29.4697 172.617 29.123C174.523 28.9496 176.43 28.9497 178.336 28.9497C188.735 28.9497 198.614 30.8565 205.719 35.0169C214.385 39.8708 218.371 47.6716 220.104 54.4323C223.224 68.127 220.797 77.1413 222.184 77.3146C222.704 77.3146 227.036 68.6471 225.13 53.7389C223.917 46.4581 219.931 36.9238 209.532 30.6832C200.693 25.3093 189.428 23.0557 177.816 23.0557Z",
    fill: "url(#paint7_linear_1_3)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M221.837 77.1413C221.837 77.1413 221.837 76.9679 221.664 76.6212C221.664 75.2344 221.664 73.5009 221.664 71.594C221.664 67.607 221.664 61.713 220.104 54.4323C218.544 48.365 214.905 40.0441 205.546 35.0169C198.787 31.0299 189.081 28.7763 177.99 28.7763C176.083 28.7763 174.177 28.7763 172.27 28.9497C147.14 29.2964 133.449 46.6315 126.69 61.193L125.997 62.4064C122.877 68.3004 120.104 73.5009 116.638 76.4479L116.464 76.6212C117.851 74.021 119.237 70.7273 120.971 67.0869C121.49 66.0468 121.837 64.8334 122.357 63.6199C124.957 57.726 128.943 48.7117 137.088 40.7375C144.714 32.9367 158.059 27.9095 171.75 27.2161C173.657 27.0428 175.737 27.0428 177.643 27.0428C190.121 27.0428 201.04 29.6431 209.012 34.6702C220.797 41.7776 223.743 53.0455 224.437 57.5526C224.61 59.4595 224.783 61.193 224.957 63.0998C224.783 71.9408 222.357 76.7946 221.837 77.1413Z",
    fill: "url(#paint8_linear_1_3)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M177.816 27.3895C190.295 27.3895 201.213 29.9898 209.185 35.0169C220.971 42.1243 223.743 53.2188 224.437 57.7259C224.61 59.6328 224.783 61.3663 224.957 63.2732C224.61 70.7273 222.877 75.4078 222.01 76.7946C222.01 75.4078 222.01 73.6743 222.01 71.7674C222.01 67.7803 222.01 61.713 220.277 54.6056C218.717 48.5383 214.905 40.2175 205.719 35.0169C198.96 31.0299 189.081 28.7763 177.99 28.7763C176.083 28.7763 174.177 28.7763 172.27 28.9497C146.794 29.2964 133.276 46.6315 126.343 61.193L125.65 62.4064C122.704 67.7803 120.277 72.6342 117.158 75.5811C118.371 73.3276 119.584 70.3806 120.971 67.2603C121.49 66.2202 121.837 65.0067 122.357 63.7932C124.957 57.8993 128.943 48.885 137.088 41.0842C144.714 33.4568 157.886 28.2562 171.577 27.7362C173.83 27.3895 175.91 27.3895 177.816 27.3895ZM177.816 26.8694C175.91 26.8694 173.83 26.8694 171.924 27.0428C158.232 27.5628 144.887 32.7634 137.088 40.5642C129.116 48.1916 125.303 56.6858 122.184 63.4465C119.584 69.3405 117.678 74.1943 115.598 77.488C115.945 77.1413 116.291 76.9679 116.811 76.6212C120.451 73.5009 123.397 67.7803 126.863 61.3663C132.929 48.5383 146.101 29.6431 172.444 29.2964C174.35 29.123 176.256 29.123 178.163 29.123C188.562 29.123 198.44 31.0299 205.546 35.1903C214.211 40.0441 218.198 47.8449 219.931 54.6056C221.49 61.713 221.664 67.607 221.49 71.7674C221.49 73.6743 221.49 75.4078 221.49 76.7946C221.49 77.3146 221.664 77.488 221.837 77.488C222.357 77.488 224.957 72.2874 225.303 63.2732C225.303 61.5397 225.13 59.6328 224.783 57.7259C223.57 50.4452 219.584 40.9109 209.185 34.6702C200.693 29.123 189.428 26.8694 177.816 26.8694Z",
    fill: "url(#paint9_radial_1_3)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M206.932 79.3948C205.373 79.0481 192.894 73.6743 182.669 57.5526C178.51 51.312 175.563 43.6845 172.27 35.3636C171.23 32.59 170.017 29.8164 168.977 27.0428C164.125 13.8681 152.86 5.89394 138.648 5.89394C138.302 5.89394 138.128 5.89394 137.782 5.89394C136.915 5.89394 135.875 5.89394 135.009 5.89394C120.624 5.89394 107.279 11.7879 100.173 21.3222C93.9341 29.123 90.4679 39.1774 90.1213 50.7919C89.7747 63.9666 94.2808 72.6342 96.3605 76.7946C96.8804 77.8347 97.4003 78.7014 97.4003 79.0481C96.3605 78.5281 86.4818 69.3405 85.6153 50.9652C85.2686 38.484 88.3882 27.7362 95.1473 18.7219C102.6 7.4541 118.544 0.173351 134.662 0.173351C135.702 0.173351 136.915 0.173351 137.955 0.346702C147.66 0.520054 156.672 3.29367 162.565 7.97415C169.151 13.1747 172.097 19.762 174.523 25.4826C175.91 29.123 177.123 32.7634 178.336 36.057C181.109 43.6845 183.362 50.2718 186.655 55.9924C192.894 67.607 200.867 74.1943 204.679 77.3146C205.719 78.3547 206.759 79.0481 206.932 79.3948Z",
    fill: "url(#paint10_linear_1_3)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M134.662 0.520054C135.702 0.520054 136.915 0.520054 137.955 0.693405C147.834 0.693405 156.672 3.46702 162.565 8.14751C168.977 13.348 172.097 19.762 174.523 25.656C175.91 29.2964 177.123 32.9367 178.336 36.2304C181.109 43.8579 183.362 50.6186 186.655 56.1658C192.894 67.7803 200.867 74.3677 204.679 77.6613C205.199 78.1814 205.893 78.7014 206.239 79.0481C202.946 77.8347 191.854 71.7674 182.842 57.7259C178.856 51.4853 175.737 43.8579 172.444 35.7104C171.404 32.9367 170.191 30.1631 169.151 27.3895C164.298 13.6947 153.033 5.54724 138.648 5.54724C138.302 5.54724 138.128 5.54724 137.782 5.54724C136.915 5.54724 135.875 5.54724 134.835 5.54724C120.451 5.54724 106.932 11.4412 99.8267 20.9755C93.5875 28.9497 90.1213 38.8307 89.7747 50.6186C89.4281 63.7932 93.9341 72.4608 96.0139 76.6212C96.3605 77.1413 96.5338 77.8347 96.7071 78.1814C94.4541 76.2745 86.4818 67.0869 85.6153 50.6186C85.2686 38.3106 88.3882 27.3895 95.1473 18.5486C102.6 7.8008 118.544 0.520054 134.662 0.520054ZM134.662 0C118.024 0 102.08 7.62745 94.8007 18.2019C86.4818 29.2964 84.922 41.2576 85.2686 50.6186C86.1352 69.5138 96.5338 79.0481 97.227 79.0481C98.4402 78.5281 89.7747 68.8204 90.1213 50.6186C90.4679 41.7776 92.5477 30.8565 100.173 21.3222C106.932 12.1346 120.104 6.06729 134.835 6.06729C135.702 6.06729 136.742 6.06729 137.608 6.06729C137.955 6.06729 138.128 6.06729 138.475 6.06729C154.593 6.06729 164.471 15.9483 168.458 27.2161C173.137 38.484 176.776 49.4051 182.149 57.7259C192.548 74.021 205.546 79.5682 206.759 79.5682C207.799 78.7014 195.494 72.2875 186.482 55.8191C181.802 47.6716 179.029 37.2705 174.35 25.3093C171.924 19.4153 168.804 12.828 162.218 7.62745C155.633 2.42692 146.274 0 137.608 0C136.915 0 135.875 0 134.662 0Z",
    fill: "url(#paint11_linear_1_3)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2409 74.541C90.2946 70.3806 86.1352 62.5798 85.4419 50.9653C85.7886 40.3908 89.0815 31.0299 94.974 23.2291C102.6 12.1346 118.544 4.85383 134.662 4.85383C135.702 4.85383 136.915 4.85383 137.955 5.02718C147.834 5.20053 156.846 7.97415 162.565 12.6546C169.151 17.8552 172.097 24.4425 174.523 30.1631C175.91 33.8035 177.123 37.4439 178.336 40.7375C181.109 48.365 183.362 54.9523 186.655 60.6729C188.562 64.1399 190.641 67.4336 193.068 70.3806C189.081 66.7402 185.615 62.4064 182.496 57.5526C178.336 51.312 175.39 43.6845 172.097 35.3636C171.057 32.59 169.844 29.8164 168.804 27.0428C164.125 13.8681 152.86 5.89394 138.648 5.89394C138.302 5.89394 138.128 5.89394 137.782 5.89394C136.915 5.89394 135.875 5.89394 135.009 5.89394C120.624 5.89394 107.279 11.7879 100.173 21.3222C93.9341 29.123 90.4679 39.1774 90.1213 50.7919C90.1213 52.0054 90.1213 53.2188 90.1213 54.4323V55.4724C89.948 61.8864 90.9879 68.4737 93.2409 74.541Z",
    fill: "url(#paint12_radial_1_3)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M134.662 5.02718C135.702 5.02718 136.915 5.02718 138.128 5.20053C147.834 5.37389 156.672 8.14751 162.565 12.828C168.977 18.0285 172.097 24.4425 174.523 30.1631C175.91 33.8035 177.123 37.4439 178.336 40.7375C181.109 48.365 183.362 54.9523 186.655 60.6729C188.042 63.2732 189.601 65.7001 191.334 68.127C188.215 65.0067 185.442 61.3663 182.842 57.3792C178.856 51.1386 175.737 43.5111 172.444 35.3636C171.404 32.59 170.191 29.8164 169.151 27.0428C164.298 13.6947 153.033 5.54724 138.648 5.54724C138.302 5.54724 138.128 5.54724 137.782 5.54724C136.915 5.54724 135.875 5.54724 134.835 5.54724C120.451 5.54724 106.932 11.4412 99.8267 20.9755C93.5875 28.9496 90.1213 38.8307 89.7747 50.6185C89.7747 51.832 89.7747 52.8721 89.7747 54.2589V54.6056V55.299C89.6014 61.3663 90.4679 67.2603 92.3743 72.9809C89.6014 68.6471 86.1352 61.3663 85.6153 50.9652C85.9619 40.3908 89.2548 31.2032 95.1473 23.2291C102.6 12.3079 118.544 5.02718 134.662 5.02718ZM134.662 4.68048C118.024 4.68048 102.08 12.3079 94.8007 22.8824C87.695 32.2433 85.6152 42.2977 85.2686 50.7919C85.9619 63.2732 90.6412 71.594 94.1074 75.7545C92.201 71.074 90.1213 64.1399 90.2946 55.1257C90.2946 54.779 90.2946 54.4323 90.2946 54.0856C90.2946 52.8721 90.2946 51.6587 90.2946 50.4452C90.6412 41.6043 92.721 30.6832 100.347 21.1488C107.106 11.9612 120.277 5.89394 135.009 5.89394C135.875 5.89394 136.915 5.89394 137.782 5.89394C138.128 5.89394 138.302 5.89394 138.648 5.89394C154.766 5.89394 164.645 15.775 168.631 27.0428C173.31 38.3106 176.95 49.2317 182.322 57.5526C186.482 64.1399 190.988 68.8204 195.147 72.2874C192.374 69.1671 189.428 65.18 186.828 60.3262C182.149 52.1787 179.376 41.7776 174.697 29.8164C172.27 23.9225 169.151 17.3351 162.565 12.1346C155.979 6.93405 146.62 4.50713 137.955 4.50713C136.915 4.68048 135.875 4.68048 134.662 4.68048Z",
    fill: "url(#paint13_linear_1_3)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4038 85.1154C57.539 85.1154 47.6603 94.3031 47.6603 109.385C47.6603 124.119 57.7123 132.96 70.7106 132.96C82.3224 132.96 94.2808 125.506 94.2808 108.518C94.1075 94.8231 85.0953 85.1154 71.4038 85.1154ZM71.0572 124.813C64.1248 124.813 59.6187 118.052 59.6187 109.211C59.6187 101.584 62.9116 93.6096 71.0572 93.6096C79.0295 93.6096 82.149 101.931 82.149 109.038C82.149 118.399 77.643 124.813 71.0572 124.813Z",
    fill: "url(#paint14_linear_1_3)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M109.705 86.3289H98.0936V132.267H109.705V86.3289Z",
    fill: "url(#paint15_linear_1_3)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M119.931 132.094V94.9965H113.692V86.3289H119.931V84.2487C119.931 71.9407 128.423 64.3133 142.114 64.3133C146.794 64.3133 152.166 65.5268 154.766 67.2603L152.166 76.1012C150.087 74.8877 146.447 73.6743 142.114 73.6743C134.142 73.6743 131.542 78.5281 131.542 84.5954V86.5023H158.925V132.44H147.314V94.9965H131.716V132.267H119.931V132.094Z",
    fill: "url(#paint16_linear_1_3)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M162.218 99.8503C162.218 94.6498 162.045 90.1426 161.872 86.1555H171.924L172.444 93.0896H172.79C174.87 89.4492 179.896 85.1154 187.522 85.1154C195.494 85.1154 203.813 90.316 203.813 104.877V132.094H192.201V106.091C192.201 99.5036 189.775 94.4764 183.362 94.4764C178.683 94.4764 175.563 97.7701 174.35 101.237C174.003 102.104 173.83 103.664 173.83 104.877V131.92H162.218V99.8503Z",
    fill: "url(#paint17_linear_1_3)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M218.717 86.3289H207.106V132.267H218.717V86.3289Z",
    fill: "url(#paint18_linear_1_3)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M239.861 74.541V86.3289H250.953V94.9965H239.861V115.279C239.861 120.999 241.421 123.773 245.754 123.773C247.834 123.773 248.873 123.599 250.26 123.253L250.433 132.094C248.7 132.787 245.581 133.307 242.114 133.307C237.782 133.307 234.315 131.92 232.062 129.493C229.463 126.893 228.423 122.559 228.423 116.665V94.9965H221.837V86.3289H228.423V77.8347L239.861 74.541Z",
    fill: "url(#paint19_linear_1_3)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M266.898 86.3289L275.043 110.945C275.91 113.718 276.95 117.185 277.643 119.786H277.99C278.683 117.185 279.549 113.718 280.416 110.771L287.522 86.3289H299.827L288.388 117.705C282.149 134.867 277.816 142.495 272.444 147.175C267.764 151.162 263.085 152.722 260.312 153.069L257.712 143.361C259.619 142.841 262.045 141.801 264.471 140.241C266.724 138.854 269.324 136.081 270.884 132.96C271.404 132.094 271.577 131.4 271.577 130.88C271.577 130.36 271.404 129.667 271.057 128.627L254.246 86.5023H266.898V86.3289Z",
    fill: "url(#paint20_linear_1_3)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5823 98.9835C30.5026 104.357 28.2496 109.731 26.3432 115.279C24.9567 109.385 23.2236 103.664 21.3172 97.4234L12.6516 68.4737H0L20.9705 131.92H32.5823C35.8752 120.479 40.3813 109.211 44.8873 98.4635C45.5806 96.5566 46.4471 94.8231 47.3137 92.9162C51.2998 84.2487 55.9792 75.7545 61.5251 67.9537H47.8336L47.6603 68.127C43.6742 74.3677 40.208 81.1284 37.0884 87.8891C35.5286 91.8761 33.9688 95.3432 32.5823 98.9835Z",
    fill: "url(#paint21_linear_1_3)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_3",
    x1: 212.865,
    y1: 79.1321,
    x2: 212.897,
    y2: 66.2596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A9DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2314,
    stopColor: "#2A7DAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5015,
    stopColor: "#225184"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729,
    stopColor: "#1C376C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902,
    stopColor: "#15285F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13235B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_3",
    x1: 212.896,
    y1: 72.05,
    x2: 212.91,
    y2: 66.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_3",
    x1: 212.865,
    y1: 78.9045,
    x2: 212.874,
    y2: 75.0176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C9E9F",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8554,
    stopColor: "#9C9E9F",
    stopOpacity: 0.0896252
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C9E9F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_3",
    x1: 103.837,
    y1: 79.1321,
    x2: 103.87,
    y2: 66.2596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97BF0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1065,
    stopColor: "#84B01C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5127,
    stopColor: "#42822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8236,
    stopColor: "#046B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00632E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_3",
    x1: 103.87,
    y1: 72.0501,
    x2: 103.884,
    y2: 66.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_3",
    x1: 103.837,
    y1: 78.9045,
    x2: 103.846,
    y2: 75.0176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C9E9F",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8554,
    stopColor: "#9C9E9F",
    stopOpacity: 0.0896252
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C9E9F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_3",
    x1: 109.918,
    y1: 51.2532,
    x2: 225.133,
    y2: 51.2532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97BF0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196,
    stopColor: "#679A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    stopColor: "#3E802D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6083,
    stopColor: "#186F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8091,
    stopColor: "#00662F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00632E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_3",
    x1: 161.363,
    y1: 51.2528,
    x2: 217.248,
    y2: 51.2528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0355776,
    stopColor: "white",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1818,
    stopColor: "#97BF0D",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4667,
    stopColor: "#97BF0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5073,
    stopColor: "#98BF12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522,
    stopColor: "#9CC120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5324,
    stopColor: "#A1C431"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5408,
    stopColor: "#A9C844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5481,
    stopColor: "#B3CD5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5545,
    stopColor: "#BFD474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5603,
    stopColor: "#CCDD92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5656,
    stopColor: "#DBE7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5706,
    stopColor: "#EBF2D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.575,
    stopColor: "#FCFDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5758,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6198,
    stopColor: "#F1F6E2",
    stopOpacity: 0.8963
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6992,
    stopColor: "#D9E5AE",
    stopOpacity: 0.7089
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7751,
    stopColor: "#C3D77D",
    stopOpacity: 0.5302
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8451,
    stopColor: "#B1CC56",
    stopOpacity: 0.3651
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    stopColor: "#A3C536",
    stopOpacity: 0.2166
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9618,
    stopColor: "#9BC01C",
    stopOpacity: 0.0899431
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97BF0D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_3",
    x1: 116.48,
    y1: 52.1472,
    x2: 225.09,
    y2: 52.1472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00632E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1909,
    stopColor: "#00662F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3917,
    stopColor: "#186F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597,
    stopColor: "#3E802D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804,
    stopColor: "#679A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97BF0D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_1_3",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(159.479 52.7939) scale(66.2258 66.2415)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0727273,
    stopColor: "white",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0820733,
    stopColor: "#EEF4DC",
    stopOpacity: 0.7804
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0940653,
    stopColor: "#DAE6B0",
    stopOpacity: 0.7039
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1062,
    stopColor: "#C7D986",
    stopOpacity: 0.6265
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1182,
    stopColor: "#B7D062",
    stopOpacity: 0.5501
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#AAC845",
    stopOpacity: 0.4746
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1416,
    stopColor: "#A0C32D",
    stopOpacity: 0.4005
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1529,
    stopColor: "#99C018",
    stopOpacity: 0.3282
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1636,
    stopColor: "#97BF0D",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4667,
    stopColor: "#97BF0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5073,
    stopColor: "#98BF12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522,
    stopColor: "#9CC120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5324,
    stopColor: "#A1C431"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5408,
    stopColor: "#A9C844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5481,
    stopColor: "#B3CD5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5545,
    stopColor: "#BFD474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5603,
    stopColor: "#CCDD92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5656,
    stopColor: "#DBE7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5706,
    stopColor: "#EBF2D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.575,
    stopColor: "#FCFDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5758,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6198,
    stopColor: "#F1F6E2",
    stopOpacity: 0.8963
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6992,
    stopColor: "#D9E5AE",
    stopOpacity: 0.7089
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7751,
    stopColor: "#C3D77D",
    stopOpacity: 0.5302
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8451,
    stopColor: "#B1CC56",
    stopOpacity: 0.3651
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    stopColor: "#A3C536",
    stopOpacity: 0.2166
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9618,
    stopColor: "#9BC01C",
    stopOpacity: 0.0899431
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97BF0D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1_3",
    x1: 85.5095,
    y1: 39.8344,
    x2: 206.881,
    y2: 39.8344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B72B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2223,
    stopColor: "#1460A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6878,
    stopColor: "#183A73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13235B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1_3",
    x1: 85.2828,
    y1: 39.8415,
    x2: 207.144,
    y2: 39.8415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B72B5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1419,
    stopColor: "#1573B5",
    stopOpacity: 0.282
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2143,
    stopColor: "#2977B8",
    stopOpacity: 0.4259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.271,
    stopColor: "#407EBC",
    stopOpacity: 0.5387
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3195,
    stopColor: "#5989C2",
    stopOpacity: 0.6352
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3629,
    stopColor: "#7599CB",
    stopOpacity: 0.7214
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4025,
    stopColor: "#94ACD6",
    stopOpacity: 0.8002
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4394,
    stopColor: "#B6C5E2",
    stopOpacity: 0.8734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#DAE1F0",
    stopOpacity: 0.9403
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5134,
    stopColor: "#ECF4FB",
    stopOpacity: 0.9724
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5325,
    stopColor: "#CDE3F4",
    stopOpacity: 0.9217
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5539,
    stopColor: "#AED3ED",
    stopOpacity: 0.8647
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5776,
    stopColor: "#91C6E8",
    stopOpacity: 0.8017
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6043,
    stopColor: "#76BBE3",
    stopOpacity: 0.7305
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6356,
    stopColor: "#5FB3E0",
    stopOpacity: 0.6473
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6742,
    stopColor: "#4BADDE",
    stopOpacity: 0.5445
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7284,
    stopColor: "#3DAADC",
    stopOpacity: 0.4003
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8788,
    stopColor: "#39A9DC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0D9F3",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_1_3",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(139.364 39.6773) scale(45.3127 45.3234)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B72B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    stopColor: "#1069AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2916,
    stopColor: "#175491"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#173770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7091,
    stopColor: "#13235B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1_3",
    x1: 85.3317,
    y1: 40.2775,
    x2: 195.172,
    y2: 40.2775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0D9F3",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1212,
    stopColor: "#39A9DC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3417,
    stopColor: "#A8D1EC",
    stopOpacity: 0.4665
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5939,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6248,
    stopColor: "#E6E2EA",
    stopOpacity: 0.9241
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7312,
    stopColor: "#988DAC",
    stopOpacity: 0.6621
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8256,
    stopColor: "#605480",
    stopOpacity: 0.4294
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9047,
    stopColor: "#3B3669",
    stopOpacity: 0.2348
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9652,
    stopColor: "#20285F",
    stopOpacity: 0.0857326
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13235B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1_3",
    x1: 70.8898,
    y1: 133.178,
    x2: 70.8898,
    y2: 85.2019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1_3",
    x1: 103.855,
    y1: 132.146,
    x2: 103.855,
    y2: 86.2431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1_3",
    x1: 136.159,
    y1: 132.146,
    x2: 136.159,
    y2: 64.1873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1_3",
    x1: 182.881,
    y1: 132.146,
    x2: 182.881,
    y2: 85.2019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1_3",
    x1: 212.88,
    y1: 132.146,
    x2: 212.88,
    y2: 86.2431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1_3",
    x1: 236.371,
    y1: 133.178,
    x2: 236.371,
    y2: 74.4614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1_3",
    x1: 277.016,
    y1: 152.882,
    x2: 277.016,
    y2: 86.2431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1_3",
    x1: 30.7508,
    y1: 132.146,
    x2: 30.7508,
    y2: 68.3824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoifinityblack);
export default __webpack_public_path__ + "static/media/voifinity.black.1ac1a7fdb371122585d152983e8ae541.svg";
export { ForwardRef as ReactComponent };